/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Validation_Error_DescriptionInputs */

const en_toast_validation_error_description = /** @type {(inputs: Toast_Validation_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The request contains invalid data. Please check your input and try again.`)
};

const nl_toast_validation_error_description = /** @type {(inputs: Toast_Validation_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het verzoek bevat ongeldige gegevens. Controleer uw invoer en probeer het opnieuw.`)
};

/**
* | output |
* | --- |
* | "The request contains invalid data. Please check your input and try again." |
*
* @param {Toast_Validation_Error_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_validation_error_description = /** @type {((inputs?: Toast_Validation_Error_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Validation_Error_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_validation_error_description(inputs)
	return en_toast_validation_error_description(inputs)
});